import styled from 'styled-components'

export default styled.div`
  overflow: ${({ overflowHidden }) => (overflowHidden ? 'hidden' : 'auto')};
`
